import { DateHelper } from '@utils/dateHelper'
import { StoreExt } from '@utils/reactExt'
import { observable, action, runInAction, computed, toJS } from 'mobx'
import { createViewModel, IViewModel } from 'mobx-utils'
import { routerStore } from '..'
import {
    DISTRIBUTION_CHANNEL_TYPE,
    ICompaniesModule,
    ICompanyDetails,
    ICompanyDocument,
    IModuleSettings
} from './type.d'
import AuthStore from '@store/authStore'
import MetaDataStore from '@store/metaDataStore'
import { ICompany } from '@store/metaDataStore/type'
import metaDataStore from '@store/metaDataStore'
import { IMedia } from '@store/mediaStore/type'
export class CompanyStore extends StoreExt {
    @observable
    companyDetails: ICompanyDetails = <ICompanyDetails>{ id: 0 }
    @observable
    path = ''
    @observable
    moduleSettings: IModuleSettings[] = []
    @observable
    moduleSettingValue: string
    @computed
    get companyDetailsViewModel() {
        return createViewModel(this.companyDetails)
    }

    @computed
    get companyModules(): ICompaniesModule[] {
        return this.companyDetails.companiesModules || []
    }
    @observable
    companyModulesActiveUpdateItem: ICompaniesModule

    @computed
    get companyModulesActiveUpdateItemViewModel(): ICompaniesModule & IViewModel<ICompaniesModule> {
        return createViewModel(this.companyModulesActiveUpdateItem)
    }
    @computed
    get companyDocuments(): ICompanyDocument[] {
        return this.companyDetails.companyDocuments || []
    }
    @action
    setcompanyModulesActiveUpdateItem = (item: ICompaniesModule) => {
        this.companyModulesActiveUpdateItem = item
    }

    @action
    getCompany = async id => {
        try {
            const company: ICompanyDetails = await this.api.company.getCompany(id)
            company.companyDocuments.forEach(i => (i.key = i.id))
            company.companiesModules.forEach(i => (i.key = i.id))
            company.companyDocuments = company.companyDocuments.filter(i => i.isActive)
            company.companiesModules = company.companiesModules.filter(i => i.status !== 3)
            company.distributionChannelsIds = company.distributionChannels.map(x => x.id)
            company.isSelectWhatsAppTemplate = company.distributionChannelsIds.some(
                x => x === DISTRIBUTION_CHANNEL_TYPE.WhatsApp
            )
            company.whatsAppTemplateId = company.distributionChannels.find(
                x => x.id == DISTRIBUTION_CHANNEL_TYPE.WhatsApp
            )?.whatsAppTemplate?.id
            company.isNew = false

            if (company.isAutomationPendingBalance) {
                company.automationApiUrls = this.ensureAllAutomationApiUrlsTypes(company.automationApiUrls, metaDataStore.automationApiUrlTypes);
            }
            runInAction('GET_COMPANY', () => {
                this.companyDetails = company
            })
        } catch (err) {
            console.error(err)
        }
    }

    @action
    initializeNewCompany = async () => {
        const defaultMedia = await this.api.company.getDefaultMedia()
        const availableCompanyId = await this.api.company.getAvailableCompanyId()
        runInAction('SET_COMPANY', () => {
            this.companyDetails = <ICompanyDetails>{
                id: availableCompanyId,
                name: null,
                type: null,
                status: null,
                logoPath: null,
                companiesModules: [],
                companyDocuments: [],
                headerImage: defaultMedia.headerImage,
                centralBannerImage: defaultMedia.centralBannerImage,
                leftBannerImage: defaultMedia.leftBannerImage,
                leftBannerLink: defaultMedia.leftBannerLink,
                centralBannerLink: defaultMedia.centralBannerLink,
                video: defaultMedia.video,
                isInMastSite: true,
                isNew: true,
                isPaymentServiceOnline: false,
                paymentServiceId: null,
                paymentTerminal: '0',
                paymentTerminalUser: null,
                paymentTerminalPassword: null,
                isPersonalArea: false,
                isViewWaterDataFromPriority: false,
                standingOrderTerminal: null,
                standingOrderTerminalUser: null,
                standingOrderTerminalPassword: null,
                isActiveStandingOrderTerminal: false,
                isParticipantInFile4: false,
                externalCrmSystemId: null,
                externalCrmSystemCompanyName: null,
                externalCrmSystemPassword: null,
                distributionChannels: [],
                distributionChannelsIds: [],
                isSelectWhatsAppTemplate: false,
                whatsAppTemplateId: null,
                waterMeterReaderSupplier: null,
                waterMeterReaderCompanyCode: null,
                waterMeterReaderSupplierApiKey: null,
                waterMeterReaderSupplierUrl: null,
                isDispalyLowerLeftBannerInMast: true,
                isDispalyTopLeftBannerInMast: true,
                isDisplayVideoInMast: true,
                billTemplateImageUrl: null,
                isShowTranslation: false,
                isRegistrationToTaagid: false,
                isMultiplePaymentsStandingOrder: false,
                isAutomationPendingBalance: false,
                automationUserName: null,
                automationCustomerId: null,
                automationCustomerSite: null,
                automationPassword: null,
                automationSender: null,
                automationApiUrls: []
            }
        })
    }

    @action
    initializeNewCompanyModule = () => {
        runInAction('SET_COMPANY', () => {
            this.companyModulesActiveUpdateItem = <ICompaniesModule>{
                companyId: this.companyDetails.id,
                moduleTypeId: null,
                status: null,
                createDate: null,
                expirationDate: null,
                isWeb: false,
                isApp: false,
                moduleSettingTypeId: null,
                id: 0,
                settings: []
            }
        })
    }

    @action
    updateCompany = async () => {
        try {
            this.companyDetailsViewModel.submit()

            await this.api.company.createOrUpdateCompany(this.companyDetails)
            runInAction('SAVE_COMPANY', () => {
                const updatedCompany: ICompany = {
                    id: this.companyDetails.id,
                    name: this.companyDetails.name,
                    status: this.companyDetails.status,
                    type: this.companyDetails.type
                }
                this.companyDetails.isConflictPaymentServiceOnline = false
                if (this.companyDetails.isNew) {
                    this.companyDetails.isNew = false
                    MetaDataStore.companies.push(updatedCompany)
                    routerStore.replace(`/company-details/${this.companyDetails.id}`)
                } else {
                    metaDataStore.companies = metaDataStore.companies.map(c =>
                        c.id === this.companyDetails.id ? updatedCompany : c
                    )
                }
            })
        } catch (err) {
            console.error(err)
        }
    }
    // modules
    @action
    addOrUpdateCompanyModule = async () => {
        try {
            this.companyModulesActiveUpdateItemViewModel.createDate = new Date()
            this.companyModulesActiveUpdateItemViewModel.companyId = this.companyDetails.id
            this.companyModulesActiveUpdateItemViewModel.submit()
            const module = toJS(this.companyModulesActiveUpdateItem)
            const id = await this.api.company.createOrUpdateCompanyModule(module)
            runInAction('SAVE_MODULE', () => {
                let newList = []
                if (module.id != 0) {
                    newList = this.companyDetails.companiesModules.map(i => (i.id === module.id ? module : i))
                } else {
                    module.id = module.key = id
                    newList = [...this.companyDetails.companiesModules, module]
                }
                this.companyDetails.companiesModules = newList
            })
        } catch (err) {
            console.error(err)
        }
    }
    @action
    removeCompanyModule = async (module: ICompaniesModule) => {
        try {
            module.status = 3
            this.api.company.createOrUpdateCompanyModule(module)
            this.companyDetails.companiesModules = [
                ...this.companyDetails.companiesModules.filter(i => i.id !== module.id)
            ]
        } catch (err) {
            console.error(err)
        }
    }

    // documents
    @action
    addCompanyDocuments = async (name: string, companyId: number, documentByte: string) => {
        const newDoc: ICompanyDocument = {
            documentName: name,
            uploaderUserName: AuthStore.userInfo.userName,
            uploadDate: DateHelper.getCurrentDate(),
            companyId: companyId,
            documentPath: null,
            isActive: true,
            id: 0,
            key: null,
            documentByte: documentByte
        }
        try {
            this.api.company.insertCompanyDocument(newDoc).then(res => {
                runInAction('ADD_DOC', () => {
                    this.companyDetails.companyDocuments = [...this.companyDocuments, res]
                })
            })
        } catch (err) {
            console.error(err)
        }
    }
    @action
    insertMediaDocument = async (name: string, companyId: number, fileByte: string, mediaType?: number) => {
        const newMedia: IMedia = {
            name: name,
            companyId: companyId,
            fileByte: fileByte,
            isActive: true,
            id: 0,
            type: mediaType
        }
        const res = await this.api.media.insertMediaDocument(newMedia)
        runInAction(() => {
            if (res.id !== 0) {
                debugger
                this.path = res.path
            }
        })
        return res
    }
    @action
    removeCompanyDocuments = (doc: ICompanyDocument) => {
        try {
            this.api.company.deleteCompanyDocument(doc)
            this.companyDetails.companyDocuments = [...this.companyDocuments.filter(i => i.id !== doc.id)]
        } catch (err) {
            console.error(err)
        }
    }
    @action
    getModuleSettings = async moduleType => {
        this.moduleSettings = []
        this.companyModulesActiveUpdateItemViewModel.settings = this.moduleSettings
        const data = await this.api.company.getModuleSettings(moduleType.moduleSettingValue, moduleType.companyId)
        runInAction(() => {
            this.moduleSettings = data
            this.companyModulesActiveUpdateItemViewModel.settings = this.moduleSettings
        })
    }

    @action
    updateRegistrationInTaagid = async (companyId: number, taagidId: number): Promise<any> => {
        try {
            const res = await this.api.company.updateRegistrationInTaagid(companyId, taagidId)
            return res
        } catch (err) {
            throw err
        }
    }

    ensureAllAutomationApiUrlsTypes = (companyAutomationUrl, allAutomationUrl) => {
        const existingTypes = new Set(companyAutomationUrl.map(x => x.type));
        const missing = allAutomationUrl.filter(x => !existingTypes.has(x.type));
        return [...companyAutomationUrl, ...missing.map(x => ({ type: x.type, url: null }))];
    }
}
export default new CompanyStore()
